import { api1C } from './api';

export const evotor1c = (data) => api1C.post('evotor', data);